import { render } from "./attendance-employee-modal.vue?vue&type=template&id=4b23a4ac"
import script from "./attendance-employee-modal.vue?vue&type=script&lang=js"
export * from "./attendance-employee-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__